import _ from 'lodash';

export const getNode = (data, pageName) => {
  const prefix = 'all';
  const suffix = 's';
  const allPagesName = [prefix, _.upperFirst(pageName), suffix].join('');
  const [edge] = _.get(data, ['prismic', allPagesName, 'edges']);
  return edge.node;
};
